import { AdhocEventRecordSchema, AssociationId, ProfilePk, RecordLog } from "../../types"
import { httpPost } from "../remoteDataProvider"

export async function createBulkDisciplineActon(
  idPassport: string,
  offence: any,
  action: any,
  selectedAssociation: string,
  selectedRoles: any,
  token: string,
) {
  const payload = {
    idPassport,
    offence,
    action,
    selectedEmployer: selectedAssociation,
    selectedRoles,
  }
  const { data } = await httpPost("people_flow_data_sync", "/data-sync/create-bulk-discipline-action", payload, token)
  if (data.result !== "success") {
    throw { code: "UnknownError" }
  }
  return data
}

export async function updateDisciplinaryData(
  selectedAssociation: string,
  disciplinaryActionsTracker: any,
  token: string,
) {
  const { data } = await httpPost(
    "people_flow_data_sync",
    "/data-sync/update-disciplinary-data",
    { selectedEmployer: selectedAssociation, disciplinaryActionsTracker },
    token,
  )
  if (data.result !== "success") {
    throw { code: "DisciplineUploadFailed" }
  }
  return data
}

export async function linkDocsToProfile(association: string, params: Record<string, any>, token: string) {
  const payload = { association, ...params }
  const { data } = await httpPost("people_flow_data_sync", "/data-sync/link-docs-to-profile", payload, token)
  if (data.result !== "success") {
    if (data.result === "doesntExist") {
      throw { code: "ProfileDoesntExist" }
    }
    throw { code: "UnknownError" }
  }
  return data
}

export async function uploadAdHocDataRecord(
  association: AssociationId,
  profilePk: ProfilePk,
  eventRecords: AdhocEventRecordSchema[],
  token: string,
) {
  const params = { eventRecordsByPk: { [profilePk]: eventRecords } }
  const { processedPks } = (
    await httpPost("people_flow_core", `/profiles/profile-event-records/${association}/adHocData`, params, token)
  ).data

  console.log("processedPks: ", processedPks)
  if (!processedPks.includes(profilePk)) {
    throw { code: "SaveAdHocDataRecordFailed" }
  }
}

export async function uploadAdHocDataRecordLogs(association: AssociationId, recordLogs: RecordLog[], token: string) {
  const params = { recordLogs }
  const { processedRecordUids } = (
    await httpPost("people_flow_core", `/profiles/profile-event-record-logs/${association}`, params, token)
  ).data
  for (const recordLog of recordLogs) {
    if (!processedRecordUids.includes(recordLog.uid)) {
      throw { code: "SaveAdHocDataRecordLogFailed" }
    }
  }
}
